import moment from 'moment';
import React, { useState } from 'react';

import { Calendar } from '@/packs/ui/components/ui/calendar';

/*
  Thin stateful wrapper over the shared packs/ui Calendar primitive.

  The primitive is fully controlled (selected + onSelect); this wrapper only owns
  the local selection state for consumers that don't track a value themselves
  (the input_date and activities_dropdown_dates Stimulus controllers).

  Nothing is selected until there is a valid value: an empty field must not render
  today as chosen, it only opens on today's month. Today then keeps its own
  "today" styling, which is what every other date field in the app shows.

  Do not reintroduce captionLayout/fromYear/toYear here: dropdown behaviour and
  the year range are the primitive's responsibility, and those were v8 props that
  react-day-picker v9 silently ignores.
*/
export function DateComponent({ value, onChange }) {
  const momentDate = value ? moment(value) : null;
  const initialDate = momentDate?.isValid() ? momentDate.toDate() : undefined;
  const [date, setDate] = useState(initialDate);

  const handleDaySelect = (selected, _triggerDate, _modifiers, e) => {
    e?.preventDefault();
    e?.stopPropagation();

    setDate(selected);
    onChange(selected);
  };

  return (
    <div className="text-slate-700 [&_*]:text-sm">
      <Calendar
        mode="single"
        defaultMonth={initialDate ?? new Date()}
        selected={date}
        onSelect={handleDaySelect}
      />
    </div>
  );
}

export default DateComponent;
